import { Button, Flex } from 'antd'
import { useTheme } from 'antd-style'
import dompurify from 'dompurify'
import { useNavigate } from 'react-router-dom'

import { GetMessagesListResponseItem } from 'src/api/requests'
import { Text, Paragraph } from 'src/components'
import { useNotificationsFormat } from 'src/hooks'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import { useStyles } from './styles'

export const NotificationPopoverCard = (
  notification: GetMessagesListResponseItem
) => {
  const { t } = useLocales()

  const { styles } = useStyles({ isRead: notification.read })
  const palette = useTheme()
  const navigate = useNavigate()

  const { getTimeDifference } = useNotificationsFormat()

  const onClick = () => {
    navigate(paths.notifications)
  }

  return (
    <Flex vertical gap={4} className={styles.notification} onClick={onClick}>
      <Flex justify="space-between" align="flex-start">
        {notification.createdOn && (
          <Text size="md" color={palette.grey.grey1}>
            {getTimeDifference(notification.createdOn)}
          </Text>
        )}

        {!notification.read && <div className={styles.dot} />}
      </Flex>

      <Paragraph weight={600} size="xl" ellipsis={{ rows: 1 }}>
        {notification.title}
      </Paragraph>

      <Paragraph weight={400} size="md" ellipsis={{ rows: 5 }}>
        <div
          dangerouslySetInnerHTML={{
            __html: dompurify.sanitize(notification?.text ?? '')
          }}
        />
      </Paragraph>

      {notification?.actionUrl && (
        <Button
          size="small"
          className={styles.viewDetails}
          type="link"
          target="_blank"
          href={notification.actionUrl}
          onClick={(e) => e.stopPropagation()}
        >
          {t('notifications.view_details')}
        </Button>
      )}
    </Flex>
  )
}
